import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "../../../../../CustomHeadlessTable/CustomTable";
import {
  getCustomInventory,
  addInventory,
  updateInventory,
  deleteInventory,
} from "../../../../../../apis/Business/InventoryApi";
import CustomInputComponent from "../../../../../CustomHeadlessTable/components/CustomInputComponent";
import { getInventoryMaterialData } from "../../../../../../apis/Dropdown";
// import { getProductDropdownLCA } from "../../../../../../apis/Bonsai/productDropdownApi";
// import { getLocationDropdownLCA } from "../../../../../../apis/Bonsai/locationDropdownApi";

const InventoryCustomTable = ({
  businessId,
  subcategory,
  subcategory_description,
  subcategoryId,
}) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  // const [dropdownAdditionalData, setDropdownAdditionalData] = useState([]);
  // const [dropdownLocation, setDropdownLocation] = useState([]);
  const [unitMaterials, setUnitMaterials] = useState({});

  const toggleColumnVisibility = useCallback((columnId) => {
    setHiddenColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  }, []);

  const fetchData = useCallback(() => {
    getInventoryMaterialData({ setDropdownData: setDropdownData });
    // getProductDropdownLCA({
    //   setDropdownData: setDropdownAdditionalData,
    // });
    // getLocationDropdownLCA({
    //   setDropdownData: setDropdownLocation,
    // });
    getCustomInventory({
      businessId: businessId,
      setObjects: setData,
      subcategory: subcategory,
      subcategoryId: subcategoryId,
    });
  }, [businessId, subcategory, subcategoryId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (data.length > 0 && dropdownData?.length > 0) {
      const newUnitMaterials = {};
      data.forEach((row) => {
        const materialValue =
          row["type_material.value"]?.value || row.type_material?.value;

        if (materialValue) {
          const selectedMaterial = dropdownData.find(
            (option) =>
              option?.material === materialValue ||
              option?.material_en === materialValue
          );

          if (selectedMaterial) {
            newUnitMaterials[row.id] = selectedMaterial.unit;
          }
        }
      });
      setUnitMaterials(newUnitMaterials);
    }
  }, [data, dropdownData]);

  const dynamicPlaceholders = useMemo(
    () => ({
      "type_material.value": {
        targetField: "weight",
        getPlaceholder: (
          selectedValue,
          dropdownData,
          rowData,
          rowId = "new"
        ) => {
          const selectedMaterial = dropdownData?.find(
            (option) =>
              option?.material === selectedValue ||
              option?.material_en === selectedValue
          );
          if (selectedMaterial) {
            // For existing rows
            if (rowId !== "new") {
              setUnitMaterials((prev) => ({
                ...prev,
                [rowId]: selectedMaterial.unit,
              }));
            } else {
              setUnitMaterials((prev) => ({
                ...prev,
                new: selectedMaterial.unit, // Use a special key for new rows
              }));
            }
          }
        },
        dropdownDataKey: "type_material.value",
      },
    }),
    []
  );

  const handleEdit = useCallback(
    (editedItem) => {
      // const foundProduct = dropdownAdditionalData?.find(
      //   (option) => option.name === editedItem["product_name.value"].value
      // );
      // const productCode = foundProduct["code"];

      // const foundLocation = dropdownLocation?.find(
      //   (option) => option.name === editedItem["location.value"].value
      // );
      // const locationCode = foundLocation.code;

      updateInventory({
        businessId,
        objectId: editedItem.id,
        ...editedItem,
        subcategory: subcategory,
        subcategory_description: subcategory_description,
        type_material: editedItem["type_material.value"]
          ? editedItem["type_material.value"].value
          : editedItem["type_material"]
          ? editedItem["type_material"].value
          : null,
        product_name: editedItem["product_name.value"]
          ? editedItem["product_name.value"].value
          : editedItem["product_name"]
          ? editedItem["product_name"].value
          : null,
        type_machinery: null,
        type_buildingcode: null,
        type_service: null,
        type_chemical: null,
        type_packaging: null,
        type_buildingmaterial: null,
        type_vehicle: null,
        subcategoryId: subcategoryId,
        // product_code: productCode,
        // location_code: locationCode,
        location: editedItem["location.value"]
          ? editedItem["location.value"].value
          : editedItem["location"]
          ? editedItem["location"].value
          : null,
        callback: fetchData,
        use_swal: true,
      });
    },
    [
      businessId,
      fetchData,
      subcategory,
      subcategory_description,
      subcategoryId,

      // dropdownLocation,
      // dropdownAdditionalData,
    ]
  );

  const handleAdd = useCallback(
    (newItem) => {
      // const foundProduct = dropdownAdditionalData?.find(
      //   (option) => option.name === newItem["product_name.value"].value
      // );
      // const productCode = foundProduct["code"];

      // const foundLocation = dropdownLocation?.find(
      //   (option) => option.name === newItem["location.value"].value
      // );
      // const locationCode = foundLocation.code;

      addInventory({
        businessId,
        ...newItem,
        type_material: newItem["type_material.value"]
          ? newItem["type_material.value"].value
          : null,
        product_name: newItem["product_name.value"]
          ? newItem["product_name.value"].value
          : null,
        type_machinery: null,
        type_buildingcode: null,
        type_service: null,
        type_chemical: null,
        type_packaging: null,
        type_buildingmaterial: null,
        type_vehicle: null,
        subcategory: subcategory,
        subcategory_description: subcategory_description,
        subcategoryId: subcategoryId,
        // product_code: productCode,
        // location_code: locationCode,
        location: newItem["location.value"]
          ? newItem["location.value"].value
          : null,
        callback: fetchData,
        use_swal: true,
      });
    },
    [
      businessId,
      fetchData,
      subcategory,
      subcategory_description,
      subcategoryId,
      // dropdownLocation,
      // dropdownAdditionalData,
    ]
  );

  const handleDelete = useCallback(
    (itemToDelete) => {
      deleteInventory({
        businessId,
        objectId: itemToDelete.id,
        callback: fetchData,
      });
    },
    [businessId, fetchData]
  );

  const columns = useMemo(
    () => [
      {
        accessor: "invoice_date",
        header: t("INVOICE_DATE"),
        type: "text",
        canHide: true,
        canSort: true,
        placeholder: t("DD_MM_YYYY"),
        optional: true,
        width: "80px",
      },
      {
        accessor: "invoice_number",
        header: t("INVOICE_NO"),
        type: "text",
        canSort: true,
        canHide: true,
        optional: true,
        width: "80px",
      },
      {
        accessor: "nickname",
        header: t("INV_NICKNAME"),
        type: "text",
        disableSortBy: true,
        placeholder: t("TYPE_HERE"),
        width: "80px",
      },
      // {
      //   accessor: "location.value",
      //   header: t("PRODUCTION_COUNTRY"),
      //   type: "dropdown",
      //   dropdownData: dropdownLocation,
      //   disableSortBy: true,
      //   width: "110px",
      //   optional: true,
      // },
      {
        accessor: "type_material.value",
        header: t("TYPE_MATERIAL"),
        type: "dropdown",
        dropdownData: dropdownData,
        // isCategory: true,
        disableSortBy: true,
        width: "110px",
        tipHeader: "Tip",
        tipBody: t("TIP_CUSTOM_MATERIAL"),
        optional: true,
      },
      // {
      //   accessor: "product_name.value",
      //   header: "Additional material",
      //   type: "dropdown",
      //   dropdownData: dropdownAdditionalData,
      //   // isCategory: true,
      //   disableSortBy: true,
      //   width: "110px",
      //   tipHeader: "Tip",
      //   tipBody: t("TIP_CUSTOM_MATERIAL"),
      //   optional: true,
      // },
      {
        accessor: "qty",
        header: `${t("AMOUNT")}`,
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "80px",
        tipHeader: "Tip",
        tipBody: t("INV_AMOUNT_TIP"),
      },
      {
        accessor: "weight",
        header: t("INV_WEIGHT"),
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "120px",
        optional: true,
      },
      {
        accessor: "life_expectancy",
        header: t("LIFE_EXPECTANCY"),
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "120px",
        optional: true,
      },
      {
        accessor: "manuel",
        header: (props) => {
          const rowId = props.row?.original?.id;
          return `Manual kgCO₂/${unitMaterials[rowId] || "xx"}`;
        },
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "120px",
        optional: true,
        unit: (rowId) => `kgCO₂e/${unitMaterials[rowId] || "xx"}`,
        tipHeader: "Tip",
        tipBody: t("TIP_CUSTOM_MANUEL"),
      },
      {
        accessor: "spacer2",
        header: "",
        type: "spacer",
        width: "20px",
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "price_invoice",
        header: t("PRICE_INVOICE"),
        type: "number",
        canSort: true,
        canHide: true,
        placeholder: "0",
        optional: true,
        subtotalUnit: "DKK",
        width: "80px",
        tipHeader: "Tip",
        tipBody: t("PRICE_INVOICE_TIP"),
      },
      {
        accessor: "carbon",
        header: t("CARBON_OUTPUT"),
        type: "custom",
        canSort: true,
        cell: ({ value }) => {
          return <CustomInputComponent value={value} readOnly />;
        },
        optional: true,
        subtotalUnit: "tCO₂e",
        subtotalFixed: true,
        width: "80px",
      },
    ],
    [dropdownData, unitMaterials, t]
  );

  const disableRules = {
    carbon: () => true,
    weight: (rowData, row) => {
      const rowId = row?.original?.id || "new";
      return unitMaterials[rowId] !== "kg";
    },
  };

  const subtotalColumns = {
    price_invoice: { label: t("TOTAL_PRICE") },
    carbon: { label: t("TOTAL_CARBON") },
  };

  const memoizedDropdownData = useMemo(
    () => ({
      "type_material.value": dropdownData,
      // "location.value": dropdownLocation,
      // "product_name.value": dropdownAdditionalData,
    }),
    [dropdownData]
  );

  return (
    <CustomTable
      columns={columns}
      data={data}
      setData={setData}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      dropdownData={memoizedDropdownData}
      subtotalColumns={subtotalColumns}
      customInputs={{ carbon: CustomInputComponent }}
      hiddenColumns={hiddenColumns}
      toggleColumnVisibility={toggleColumnVisibility}
      disableRules={disableRules}
      dynamicPlaceholders={dynamicPlaceholders}
    />
  );
};

export default InventoryCustomTable;
